import { render } from "./SelectStudentsForm.vue?vue&type=template&id=817aa460&scoped=true"
import script from "./SelectStudentsForm.vue?vue&type=script&lang=js"
export * from "./SelectStudentsForm.vue?vue&type=script&lang=js"

import "./SelectStudentsForm.vue?vue&type=style&index=0&id=817aa460&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817aa460"]])

export default __exports__